/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import useEbt from '@modules/ebt/hook'
import type { UseEbtReportEventRecord } from '@modules/ebt/types'

type EventType = 'trial_interview_callout'

interface InterviewCalloutEventSchema {
  user_id: number
}

export const useEbtInterviewCallout = (): UseEbtReportEventRecord<
  EventType,
  InterviewCalloutEventSchema
> => {
  const reportEbtEvent = useEbt<EventType, InterviewCalloutEventSchema>({
    eventType: 'trial_interview_callout',
    schemaProps: {
      user_id: {
        description: 'User ID',
        keywordType: 'long',
      },
    },
  })

  return {
    reportTrialInterviewCalloutEbt: ({ user_id }) =>
      reportEbtEvent('trial_interview_callout', {
        user_id,
      }),
  }
}
